export const Label = ({ value }) => {
    return <span className="font-weight-bold">{value}:</span>;
}